// 先に定義（超重要）
const animTiming = {
  duration: 600,
  easing: 'cubic-bezier(.19, 1, .22, 1)',
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq__item, .recipient-note-accordion').forEach((el) => {
    const summary = el.querySelector('summary');
    const answer  = el.querySelector('.faq__answer') ||
                    el.querySelector('.recipient-note-accordion__content');
    if (!summary || !answer) return;

    // 初期（閉じてるときは0）
    if (!el.hasAttribute('open')) {
      answer.style.height = '0px';
      answer.style.opacity = '0';
      answer.style.overflow = 'hidden';
    }

    const cancelIfRunning = () => {
      if (answer._anim) {
        answer._anim.cancel();
        answer._anim = null;
      }
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      cancelIfRunning();

      const isOpen = el.hasAttribute('open');

      if (isOpen) {
        const fromH = answer.scrollHeight;
        answer.style.overflow = 'hidden';

        const anim = answer.animate(
          [{ height: fromH + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          animTiming
        );
        answer._anim = anim;

      anim.onfinish = () => {
        el.removeAttribute('open');
        answer.style.height = '0px';
        answer.style.opacity = '0';
        answer.style.overflow = 'hidden';
        answer._anim = null;
      };


      } else {
        // ---- open ----
        el.setAttribute('open', '');

        answer.style.overflow = 'hidden';
        answer.style.height = '0px';
        answer.style.opacity = '0';

        requestAnimationFrame(() => {
          const toH = answer.scrollHeight;

          const anim = answer.animate(
            [
              { height: '0px', opacity: 0 },
              { height: toH + 'px', opacity: 1 },
            ],
            animTiming
          );

          answer._anim = anim;

          anim.onfinish = () => {
              answer.style.height = 'auto';
              answer.style.opacity = '1';
              answer.style.overflow = 'visible';
              answer._anim = null;
            };

        });

      }
    });
  });
});
